import { useCountries } from "@/queries/use-locations.query.ts";
import { useRecent } from "@/hooks/use-recent.hook.ts";
import { ApiRecentKey } from "@/types/recents/recents.types.ts";
import { Select } from "@skailer-com/uikit";
import { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

type CountrySelectProps = Omit<
  ComponentProps<typeof Select>,
  "options" | "recentOptions" | "recentLabel"
>;

export function CountrySelect({ isLoading, ...props }: CountrySelectProps) {
  const { t } = useTranslation();
  const { data: countries, isLoading: isCountriesLoading } = useCountries();
  const { getRecentOptions } = useRecent();

  return (
    <Select
      {...props}
      options={countries ?? []}
      recentOptions={getRecentOptions(ApiRecentKey.country, countries ?? [])}
      recentLabel={t("common:recent")}
      isLoading={isLoading ?? isCountriesLoading}
    />
  );
}
